import { toQueryString } from '@croquiscom/web2app';
import getConfig from 'next/config';
// eslint-disable-next-line import/no-named-as-default
import NextRouter from 'next/router';

import { checkZPayFunctionExists, ZpayEvent } from '@common/log-manager';

import { match } from './functions';
import { Route } from './Route';
import { ZpayHeaderType } from './types';

import { UrlObject } from 'url';

export * from './functions';
export * from './shortcuts';
export * from './types';

const config = getConfig().publicRuntimeConfig.config;

interface TransitionOptions {
  shallow?: boolean;
  locale?: string | false;
  scroll?: boolean;
}

interface ZPayFnOptions {
  action?: 'close' | 'createOrderSheet';
  type?: ZpayHeaderType;
  title?: string;
  disable_zpay_function?: boolean;
}

const fetchAppToUrl = (url: string) => {
  if (!url.startsWith('http')) {
    // if (isBrowser() && window.location.pathname.startsWith('/app/')) {
    //   url = `/app${url.replace(/^\/app/, '')}`;
    // }
    return `${config.appUrl}${url}`;
  }
  return url;
};

const hrefToNextRouteProps = (href: string | UrlObject) => {
  const { route } = match(href);
  if (typeof href === 'object' && href.pathname) {
    href.pathname = fetchAppToUrl(href.pathname);
  } else if (typeof href === 'string') {
    href = fetchAppToUrl(href);
  }
  return route ? { as: href, href, route } : { as: href, href };
};

const handleChangeRouteForZPay =
  (route: Route | undefined, as: string | UrlObject, options: ZPayFnOptions) =>
  (fallback: () => void = () => undefined) => {
    const url =
      typeof as !== 'string' && as.query
        ? `${as.pathname}?${typeof as.query === 'string' ? as.query : toQueryString(as.query)}`
        : (as as string);
    const title = options.title ? options.title : route?.title ? route.title : '';
    const type = options.type ? options.type : route?.type ? route.type : 'normal';

    if (options.disable_zpay_function || !checkZPayFunctionExists(window)) {
      return fallback();
    }
    switch (options.action) {
      case 'close':
        return ZpayEvent.close();
      case 'createOrderSheet':
        return ZpayEvent.createOrderSheet(url, title, type);
      default:
        return ZpayEvent.open(url, title, type);
    }
  };

export const Router = {
  push: (
    url: string | UrlObject,
    zpayFnOptions: ZPayFnOptions = { disable_zpay_function: false },
    options?: TransitionOptions,
  ) => {
    const { href, as, route } = hrefToNextRouteProps(url);
    handleChangeRouteForZPay(
      route,
      as,
      zpayFnOptions,
    )(() => {
      NextRouter.push(href, as, options);
    });
  },

  replace: (
    url: string | UrlObject,
    zpayFnOptions: ZPayFnOptions = { disable_zpay_function: false },
    options?: TransitionOptions,
  ) => {
    const { href, as, route } = hrefToNextRouteProps(url);
    handleChangeRouteForZPay(
      route,
      as,
      zpayFnOptions,
    )(() => {
      NextRouter.replace(href, as, options);
    });
  },

  open: (url: string | UrlObject, zpayFnOptions: ZPayFnOptions = { disable_zpay_function: false }) => {
    const { href, as, route } = hrefToNextRouteProps(url);
    handleChangeRouteForZPay(
      route,
      as,
      zpayFnOptions,
    )(() => {
      window.open(href as string, '_blank');
    });
  },
};
